import { API_URL } from '../../../app-config/constants';
import { get } from '../request';

getAll.operation = 'READ';
getAll.idFrom = 'ARGS';
export function getAll(companyId, startDate, endDate) {
    const params = { startDate, endDate };
    return get(`${API_URL}/engagement/${companyId}`, { getData: params });
}
